module.exports = {"button.check.availability":"Check availability"}


//////////////////
// WEBPACK FOOTER
// ./src/static/locales/de.json
// module id = 332
// module chunks = 0